/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import gridStyle from '@pages/forms/Grid.module.scss';
import { Accordion, TileRadio, TextInput } from '@components';
import { tile } from '@interfaces/interfaces';
import { iCourtFormValues } from '@services/CourtService';
import classnames from 'classnames';
import emailNotif from '../../../../images/emailviewv2.png';
import mobileNotif from '../../../../images/mobileview.png';

import styles from './CourtStep3.module.scss';

function CourtStep3(): ReactElement {
  const { values, errors, touched }: { values: iCourtFormValues, errors: any, touched: any } = useFormikContext();

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];

  const TILE_DATA_NOTIFICATION_TYPE: tile[] = [
    {
      body: 'No thanks',
      value: 'none',
    },
    {
      body: 'To my mobile',
      value: 'mobile',
    },
    {
      body: 'To my email',
      value: 'email',
    },
    {
      body: 'To both',
      value: 'both',
    },
  ];

  const notificationInformation = (): ReactElement => (
    <>
      <div className={styles.bitmapSection}>
        <span className={styles.bitmapTitle}>Email notification</span>
        <span className={styles.bitmapTitle}>Mobile notification</span>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={emailNotif} alt="email notification view" />
        </div>
        <div className={styles.bitmapImage}>
          <img className={styles.image} src={mobileNotif} alt="mobile notification view" />
        </div>
      </div>
    </>
  );

  return (
    <div className={gridStyle.form}>
      <span className="vfH2">Form options</span>
      <span className="SubHeadingH3">Save your form as you go?</span>
      <div className={classnames({
            [styles.divWhitespace]: true,
            [styles.titleError]: getIn(errors, 'SaveYesNo') && getIn(touched, 'SaveYesNo'),
          })}>
        In case you are unable to complete this application all at once, please select YES so you can return to the form later.
      </div>
      <Field name="SaveYesNo" component={TileRadio} tileData={TILE_DATA} orientationRow />
      <div className={styles.divWhitespace}>Your form content is saved behind a secure portal.</div>
      {values.SaveYesNo === 'true' && (
        <>
          <span className="vfH2">Send notifications of uncompleted forms?</span>
          <div>We can send you a notification to remind you to come back and submit the application.</div>
          <Field name="SaveOptions" component={TileRadio} tileData={TILE_DATA_NOTIFICATION_TYPE} orientationRow />
          {(values.SaveOptions === 'email' || values.SaveOptions === 'both') && <Field name="saveEmail" title="Your email address" component={TextInput} isMandatory />}
          {(values.SaveOptions === 'mobile' || values.SaveOptions === 'both') && <Field name="saveMobile" title="Your mobile phone number" component={TextInput} isMandatory />}
          {(values.SaveOptions === 'mobile' || values.SaveOptions === 'email' || values.SaveOptions === 'both') && (
            <p>
              I understand that by providing contact details, Fines Victoria may update its records using these details and that I may be contacted regarding my outstanding fines.
            </p>
          )}
          <br />
          <Accordion title="What will notifications look like" popupContent={notificationInformation()} />
        </>
      )}
    </div>
  );
}

export default CourtStep3;
